export default "__VITE_ASSET__J16l$CWQ__"